<template>
  <div id="ag-grid-demo">
    <div v-if="selectedSociety">
      <div class="vx-row">
        <!-- USER STAT CARD -->
        <div class="vx-col flex-1">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="UserIcon"
            :statistic="convertNumberToFrenchFormat(analyticsTotalData[0])"
            statisticTitle="Utilisateurs"
          />
        </div>
        <!-- CONV RATE CARD -->
        <div class="vx-col flex-1" v-if="selectedSociety.is_ecommerce == 1">
          <vx-tooltip
            title="Taux de conversion"
            text="Ratio entre le nombre de conversions (quantité d’achats) et les sessions."
            position="top"
          >
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="HeartIcon"
              :statistic="convertNumberToFrenchFormatPercent(analyticsTotalData[6])"
              statisticTitle="Tx de conversion"
              color="danger"
            />
          </vx-tooltip>
        </div>
        <!-- NEW USERS CARD -->
        <div class="vx-col flex-1" v-if="selectedSociety.is_ecommerce == 0">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="SmileIcon"
            :statistic="convertNumberToFrenchFormat(analyticsTotalData[1])"
            statisticTitle="Nouveaux utilisateurs"
            color="success"
          />
        </div>
        <!-- TRANSACTIONS CARD -->
        <div class="vx-col flex-1" v-if="selectedSociety.is_ecommerce == 1">
          <vx-tooltip
            title="Transaction"
            text="Nombre de transactions (e-commerce) enregistrées sur la période définie."
            position="top"
          >
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="SmileIcon"
              :statistic="convertNumberToFrenchFormat(analyticsTotalData[7])"
              statisticTitle="Transactions"
              color="success"
            />
          </vx-tooltip>
        </div>
        <!-- REVENUE CARD -->
        <div class="vx-col flex-1" v-if="selectedSociety.is_ecommerce == 1">
          <vx-tooltip
            title="Chiffre d'affaire"
            text="Chiffre d’affaires (e-commerce) réalisé sur la période définie."
            position="top"
          >
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="TruckIcon"
              :statistic="
                convertNumberToFrenchCurrency(analyticsTotalData[8])
              "
              statisticTitle="Chiffre d'affaire"
              color="warning"
            />
          </vx-tooltip>
        </div>
      </div>

      <!-- MAIN TABLE -->
      <div class="vx-col w-full mb-base">
        <!-- PERFORMANCE TABLE -->
        <PerformanceTable
          v-if="selectedSociety"
          :society="selectedSociety"
          :performanceData="analyticsData"
          :performanceGlobalData="analyticsTotalData"
          :comparisonGlobalData="analyticsOldTotalData"
          :fromDate="fromDate"
          :toDate="toDate"
          :comparingFromDate="compareFromDateShow"
          :comparingToDate="compareToDateShow"
          :hasComparison="hasFilter"
        />
      </div>

      <div class="radial_container mt-6" v-if="organicData">
        <!-- RADIAL CHART -->
        <!-- SEO PART -->
        <RadialChart
          :chartParams="seoRadialChartOptions"
          :isMoney="false"
          :isPercent="false"
        />

        <!-- E-COMMERCE ONLY -->
        <!-- SEO CONV -->
        <RadialChart
          :chartParams="conversionRadialChartOptions"
          :isMoney="false"
          :isPercent="false"
          v-if="selectedSociety.is_ecommerce == 1"
        />

        <!-- SEO REVENUE -->
        <RadialChart
          :chartParams="revenueRadialChartOptions"
          :isMoney="true"
          :isPercent="false"
          v-if="selectedSociety.is_ecommerce == 1"
        />
      </div>
      <!-- E-COMMERCE ONLY -->
      <div class="radial_container">
        <!-- SEO ALL REVENUE -->
        <RadialChart
          :chartParams="allRevenueRadialChartOptions"
          :isMoney="true"
          :isPercent="false"
          v-if="selectedSociety.is_ecommerce == 1"
        />
        <!-- SEO CONV RATE -->
        <DuoBarChart
          class="mb-4"
          :chartParams="conversionRateColumnChartOptions"
          :isPercent="true"
          v-if="selectedSociety.is_ecommerce == 1"
        />
        <!-- INVISIBLE DIV TO FIX CARDS WIDTH -->
        <div class="md:w-1/3 mr-4"></div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCookies from "vue-cookies";
import {AgGridVue} from "ag-grid-vue";
import StatisticsCardLine from "../../components/views/dashboard/statistics-cards/StatisticsCardLine.vue";
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import "../../assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import "flatpickr/dist/flatpickr.css";

// CUSTOM COMPONENTS
import DuoBarChart from "@/components/charts/DuoBarChart.vue";
import RadialChart from "@/components/charts/RadialChart.vue";
import PerformanceTable from "@/components/tables/PerformanceTable.vue";

// MIXINS
import utilsMixin from "../../mixins/utilsMixin";
import chartsMixin from "../../mixins/chartsMixin";
import seoMixin from "../../mixins/seoMixin";

export default {
	name: "PerformanceStatistics",
	mixins: [utilsMixin, chartsMixin, seoMixin],
	components: {
		StatisticsCardLine,
		AgGridVue,
		Datepicker,
		DuoBarChart,
		RadialChart,
		flatPickr,
		PerformanceTable
	},
	data() {
		return {
			currentUser: VueCookies.get("userInfo"),
			// DATE PICKER DATA
			fromDate: null,
			toDate: null,
			compareFromDate: null,
			compareFromDateShow: null,
			compareToDate: null,
			compareToDateShow: null,
			configFromDatePicker: {
				maxDate: new Date(),
				dateFormat: "d/m/Y"
			},
			configToDatePicker: {
				maxDate: new Date(),
				dateFormat: "d/m/Y"
			},
			today: new Date(
				new Date().getFullYear(),
				new Date().getMonth(),
				new Date().getDate()
			)
				.toISOString()
				.slice(0, 10),
			oneYearAgo: false,
			sixMonthsAgo: false,

			hasFilter: false,
			loaded: false,
			// society: null,
			apiUrl: this.$store.state.backendApiUrl,
			searchQuery: "",
			analyticsData: new Array(), // STORE DATA FROM GOOGLE API
			analyticsTotalData: new Array(), // STORE DATA FROM GOOGLE API
			analyticsOldTotalData: new Array(), // STORE DATA FROM GOOGLE API
			compareAnalyticsData: new Array(), // STORE DATA FROM GOOGLE API
			oldAnalyticsData: new Array(), // STORE DATA FROM GOOGLE API
			organicData: new Array(), // STORE DATA FROM GOOGLE API
			mcfDataTotal: 0, // STORE DATA FROM GOOGLE API
			mcfData: new Array(),
			gridOptions: {},
			maxPageNumbers: 7,
			gridApi: null,
			defaultColDef: {
				sortable: true,
				editable: true,
				resizable: true,
				suppressMenu: true
			},

			// SEO DATA + CHART OPTIONS
			seoRadialChartOptions: {},
			conversionRadialChartOptions: {},
			revenueRadialChartOptions: {},
			allRevenueRadialChartOptions: {},
			conversionRateColumnChartOptions: {},
			radialSeries: [],
			radialOptions: [],
			organicTotal: 0,
			organicConversionTotal: 0,
			organicRevenueTotal: 0,
			organicConversionAverage: 0,
			analyticsDataTotal: 0
		};
	},

	created() {
		//console.log("created");
		this.fromDate = this.statDateFilter.fromDate;
		this.toDate = this.statDateFilter.toDate;
		this.compareFromDate = this.statDateFilter.compareFromDate;
		this.compareFromDateShow = this.statDateFilter.compareFromDateShow;
		this.compareToDate = this.statDateFilter.compareToDate;
		this.compareToDateShow = this.statDateFilter.compareToDateShow;
		this.oneYearAgo = this.statDateFilter.oneYearAgo;
		this.sixMonthsAgo = this.statDateFilter.sixMonthsAgo;
		this.loaded = false;
		// this.openLoading();
		if(this.selectedSociety && this.selectedSociety.analytics_id) {
			this.queryAnalyticsData(this.selectedSociety.analytics_id);
			this.queryAnalyticsOrganicData(this.selectedSociety.analytics_id);
			this.queryAnalyticsOldData(this.selectedSociety.analytics_id);
			this.queryMCFData(this.selectedSociety.analytics_id);
			this.filter();
		}
	},
	computed: {
		statDateFilter(){
			return this.$store.state.statDateFilter;
		},
		paginationPageSize() {
			if(this.gridApi) return this.gridApi.paginationGetPageSize();
			else return 50;
		},
		selectedSociety(){
			return this.$store.state.activeUserSociety;
		},
		totalPages() {
			if(this.gridApi) return this.gridApi.paginationGetTotalPages();
			else return 0;
		},
		currentPage: {
			get() {
				if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
				else return 1;
			},
			set(val) {
				this.gridApi.paginationGoToPage(val - 1);
			}
		}
	},
	watch: {
		"$store.state.windowWidth"(val) {
			if(val <= 576) {
				this.maxPageNumbers = 4;
				this.gridOptions.columnApi.setColumnPinned("email", null);
			}
			else this.gridOptions.columnApi.setColumnPinned("email", "left");
		},

		selectedSociety: function(data) {
			/*
			 * this.openLoading();
			 * Update the last society item
			 */
			sessionStorage.setItem("lastSociety", data.id);
			if(data.analytics_id) {
				this.queryAnalyticsData(data.analytics_id);
				this.queryAnalyticsOrganicData(data.analytics_id);
				this.queryAnalyticsOldData(data.analytics_id);
				this.queryMCFData(data.analytics_id);
				// this.filter()
			}
			/*
			 *  else {
			 *   this.society = null;
			 * }
			 */
		},
		statDateFilter: function(data){
			this.fromDate= data.fromDate;
			this.toDate= data.toDate;
			this.compareFromDate= data.compareFromDate;
			this.compareFromDateShow= data.compareFromDateShow;
			this.compareToDate= data.compareToDate;
			this.compareToDateShow= data.compareToDateShow;
			this.oneYearAgo= data.oneYearAgo;
			this.sixMonthsAgo= data.sixMonthsAgo;
			// this.filter()
		}
	},
	methods: {
		updateSearchQuery(val) {
			this.gridApi.setQuickFilter(val);
		},
		/**
		 * Starts a spinning loader
		 */
		openLoading() {
			this.$vs.loading();
			setTimeout(() => this.$vs.loading.close(), 2000);
		},
		/**
		 * When the user selects date in the datepicker and click filter,
		 * The function request analytics api to get new data based on the selected dates
		 */
		filter() {
			let viewId = this.selectedSociety.analytics_id;
			let fromDate = null;
			let toDate = this.today; // default is today date
			if(
				this.fromDate &&
        !this.compareFromDate &&
        !this.compareToDate &&
        !this.oneYearAgo &&
        !this.sixMonthsAgo
			) {
				// Starts the spinning loader
				this.$vs.loading();
				setTimeout(() => this.$vs.loading.close(), 2000);

				// Query analytics data for a domain
				fromDate = this.fromDate
					.split("/")
					.reverse()
					.join("-");
				if(this.toDate != null) {
					toDate = this.toDate
						.split("/")
						.reverse()
						.join("-");
				}
				this.$http
					.post(this.apiUrl + "analytic/site/data", {
						viewId: viewId,
						fromDate: fromDate,
						toDate: toDate
					})
					.then(res => {
						this.analyticsData = res.data.data.reports[0].data.rows;
						this.analyticsTotalData = res.data.data.reports[0].data.totals[0].values;
						this.analyticsDataTotal = parseInt(res.data.data.reports[0].data.totals[0].values[2]);
					})
					.catch(err => console.error(err));

				this.$http
					.post(this.apiUrl + "analytic/site/mcf", {
						viewId: viewId,
						fromDate: fromDate,
						toDate: toDate
					})
					.then(res => {
						this.mcfData = res.data.data.rows;
						let total = 0;
						if(this.mcfData != null) {
							for(var i = 0; i < Object.keys(this.mcfData).length; i++) {
								// CHECK IF THE DATA STARTS BY A ORGANIC ACTION AND FINISHES BY SOMETHING ELSE
								if(
									this.mcfData[i][0].conversionPathValue.length > 1 &&
                  this.mcfData[i][0].conversionPathValue[0].nodeValue.includes(
                  	"organic"
                  ) &&
                  this.mcfData[i][0].conversionPathValue[0].nodeValue !=
                    this.mcfData[i][0].conversionPathValue.slice(-1)[0]
                    	.nodeValue
								) {
									total += parseFloat(this.mcfData[i][1]["primitiveValue"]);
								}
							}
						}
						this.mcfDataTotal = total;
					})
					.catch(err => console.error(err));
			}
			if(
				(this.compareFromDate && this.compareToDate && this.fromDate) ||
        (this.fromDate && this.oneYearAgo) ||
        (this.fromDate && this.sixMonthsAgo)
			) {
				// Starts the spinning loader
				this.$vs.loading();
				setTimeout(() => this.$vs.loading.close(), 2000);
				fromDate = this.fromDate
					.split("/")
					.reverse()
					.join("-");
				if(this.toDate != null) {
					toDate = this.toDate
						.split("/")
						.reverse()
						.join("-");
				}
				let compareFromDate = null;
				let compareToDate = null;
				if(this.oneYearAgo) {
					compareFromDate = this.getDateOneYearOff(fromDate);
					compareToDate = this.getDateOneYearOff(toDate);
					this.compareFromDateShow = this.getDateOneYearOff(fromDate)
						.split("-")
						.reverse()
						.join("/");
					this.compareToDateShow = this.getDateOneYearOff(toDate)
						.split("-")
						.reverse()
						.join("/");
				}
				if(this.sixMonthsAgo) {
					compareFromDate = this.getDateSixMonthsOff(fromDate);
					compareToDate = this.getDateSixMonthsOff(toDate);
					this.compareFromDateShow = this.getDateSixMonthsOff(fromDate)
						.split("-")
						.reverse()
						.join("/");
					this.compareToDateShow = this.getDateSixMonthsOff(toDate)
						.split("-")
						.reverse()
						.join("/");
				}
				if(this.compareFromDate && this.compareToDate) {
					compareFromDate = this.compareFromDate
						.split("/")
						.reverse()
						.join("-");
					compareToDate = this.compareToDate
						.split("/")
						.reverse()
						.join("-");
					this.compareFromDateShow = this.compareFromDate;
					this.compareToDateShow = this.compareToDate;
				}
				this.$http
					.post(this.apiUrl + "analytic/site/comparingdata", {
						viewId: viewId,
						fromDate: fromDate,
						toDate: toDate,
						compareFromDate: compareFromDate,
						compareToDate: compareToDate
					})
					.then(res => {
						this.analyticsData = res.data.data.reports[0].data.rows;
						this.analyticsTotalData =
              res.data.data.reports[0].data.totals[0].values;
						this.analyticsOldTotalData =
              res.data.data.reports[0].data.totals[1].values;
						this.analyticsDataTotal = parseInt(
							res.data.data.reports[0].data.totals[0].values[2]
						);
						this.hasFilter = true;
					})
					.catch(err => console.error(err));
			}
			// Query organic data for a domain
			this.$http
				.post(this.apiUrl + "analytic/site/organic", {
					viewId: viewId,
					fromDate: fromDate,
					toDate: toDate
				})
				.then(res => {
					this.organicData = res.data.data.reports[0].data.rows;
					//console.log("res.data.data.reports[0].data.totals[0].values[0]", res.data.data.reports[0].data.totals[0].values[0]);
					this.organicTotal = parseInt(
						res.data.data.reports[0].data.totals[0].values[0]
					);
					//console.log("this.organicTotal", this.organicTotal);
				})
				.catch(err => console.error(err));

			this.$http
				.post(this.apiUrl + "analytic/site/mcf", {
					viewId: viewId,
					fromDate: fromDate,
					toDate: toDate
				})
				.then(res => {
					this.mcfData = res.data.data.rows;
					let total = 0;
					if(res.data.data.rows != null) {
						for(var i = 0; i < Object.keys(this.mcfData).length; i++) {
							// CHECK IF THE DATA STARTS BY A ORGANIC ACTION AND FINISHES BY SOMETHING ELSE
							if(
								this.mcfData[i][0].conversionPathValue.length > 1 &&
                this.mcfData[i][0].conversionPathValue[0].nodeValue.includes(
                	"organic"
                ) &&
                this.mcfData[i][0].conversionPathValue[0].nodeValue !=
                  this.mcfData[i][0].conversionPathValue.slice(-1)[0].nodeValue
							) {
								total += parseFloat(this.mcfData[i][1]["primitiveValue"]);
							}
						}
					}
					this.mcfDataTotal = total;
				})
				.catch(err => console.error(err));
		},

		/**
		 * Request analytics API to get data for a domain
		 * @param {number} viewId - ID of a analytics view
		 */
		queryAnalyticsData(viewId) {
			//console.log("queryAnalyticsData is called");
			this.$http
				.post(this.apiUrl + "analytic/site/data", {
					viewId: viewId,
					fromDate: this.fromDate,
					toDate: this.toDate
				})
				.then(res => {
					this.analyticsData = res.data.data.reports[0].data.rows;
					this.analyticsTotalData =
            res.data.data.reports[0].data.totals[0].values;
					this.analyticsDataTotal = parseInt(
						res.data.data.reports[0].data.totals[0].values[2]
					); // TOTAL SESSION
				})
				.catch(err => console.error(err));
		},

		/**
		 * Request analytics API to get data for a domain, one week ago
		 * @param {number} viewId - ID of an analytics view
		 */
		queryAnalyticsOldData(viewId) {
			//console.log("querAnalyticsOld is called");
			this.$http
				.post(this.apiUrl + "analytic/site/olddata", {
					viewId: viewId,
					fromDate: this.fromDate,
					toDate: this.toDate
				})
				.then(
					res => (this.oldAnalyticsData = res.data.data.reports[0].data.rows)
				)
				.catch(err => console.error(err));
		},

		/**
		 * Query API to get Multi channel funnel data for a domain
		 * @param {number} viewId - ID of an analytics view
		 */
		queryMCFData(viewId) {
			////console.log("queryMCF is called");
			this.$http
				.post(this.apiUrl + "analytic/site/mcf", {
					viewId: viewId,
					fromDate: this.fromDate,
					toDate: this.toDate
				})
				.then(res => {
					this.mcfData = res.data.data.rows;
					let total = 0;
					if((res.data.data.rows = !null)) {
						for(var i = 0; i < Object.keys(this.mcfData).length; i++) {
							// CHECK IF THE DATA STARTS BY A ORGANIC ACTION AND FINISHES BY SOMETHING ELSE
							if(
								this.mcfData[i][0].conversionPathValue.length > 1 &&
                this.mcfData[i][0].conversionPathValue[0].nodeValue.includes(
                	"organic"
                ) &&
                this.mcfData[i][0].conversionPathValue[0].nodeValue !=
                  this.mcfData[i][0].conversionPathValue.slice(-1)[0].nodeValue
							) {
								total += parseFloat(this.mcfData[i][1]["primitiveValue"]);
							}
						}
					}
					this.mcfDataTotal = total;
				})
				.catch(err => console.error(err));
		},

		/**
		 * Request analytics API to get organic data for a domain
		 * @param {number} viewId - ID of an analytics view
		 */
		queryAnalyticsOrganicData(viewId) {
			//console.log("queryAnalyticsOrgan is called");
			this.$http
				.post(this.apiUrl + "analytic/site/organic", {
					viewId: viewId,
					fromDate: this.fromDate,
					toDate: this.toDate
				})
				.then(res => {
					this.organicData = res.data.data.reports[0].data.rows;
					//console.log("2: res.data.data.reports[0].data.totals[0].values[0]", res.data.data.reports[0].data.totals);
					this.organicTotal = parseInt(
						res.data.data.reports[0].data.totals[0].values[0]
					);
					//console.log("2 this.organicTotal", this.organicTotal);
				})
				.catch(err => console.error(err));
		},

		/**
		 * Calculates the total for the Multi-channel funnel data
		 * @param {Array<object>} data - Array of data from analytics
		 * @return {number} total from MCF data
		 */
		getMCFTotal(data) {
			let total = 0;
			for(var i = 0; i < Object.keys(data).length; i++) {
				total += parseFloat(data[i][2]["primitiveValue"]);
			}
			return total;
		},

		/**
		 * Once called, display the comparison option available
		 */
		displayOptions() {
			//console.log("Display option is click");
			let container = document.getElementsByClassName("comparing_container");
			if(container[0].style.display == "") {
				container[0].style.display = "flex";
			}
			else{
				container[0].style.display = "";
			}
		},

		/**
		 * Once called, all filters are reset (front only)
		 */
		resetFilter() {
			//console.log("reset");
			this.oneYearAgo = false;
			this.sixMonthsAgo = false;
			this.compareFromDate = null;
			this.compareToDate = null;
		}
	},
	mounted() {
		this.gridApi = this.gridOptions.api;

		/*
		 * =================================================================
		 * NOTE:
		 * Header is not aligned properly in RTL version of agGrid table.
		 * However, we given fix to this issue. If you want more robust solution please contact them at gitHub
		 * =================================================================
		 */
		if(this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector(
				".ag-header-container"
			);
			header.style.left = `-${String(
				Number(header.style.transform.slice(11, -3)) + 9
			)}px`;
		}
	},
	beforeUpdate() {
		/*
		 *  SET RADIAL CHART OPTIONS
		 * this.mcfDataTotal = this.getMCFTotal(this.mcfData);
		 */
		this.seoRadialChartOptions = this.setRadialChartOptions(
			"Poids du SEO",
			this.organicTotal,
			this.analyticsDataTotal,
			"Visites SEO"
		);
		this.conversionRadialChartOptions = this.setRadialChartOptions(
			"Poids du SEO",
			this.organicConversionTotal,
			this.analyticsTotalData[7],
			"Conversion SEO"
		);
		this.revenueRadialChartOptions = this.setRadialChartOptions(
			"Poids du SEO",
			parseFloat(this.organicRevenueTotal).toFixed(2),
			parseFloat(this.analyticsTotalData[8]).toFixed(2),
			"Revenue SEO"
		);
		this.allRevenueRadialChartOptions = this.setRadialChartOptions(
			"Poids du SEO",
			parseFloat(this.organicRevenueTotal + this.mcfDataTotal).toFixed(2),
			parseFloat(this.analyticsTotalData[8]).toFixed(2),
			"Revenue SEO + indirect"
		);
		// SET TOTAL FOR ORGANIC DATA
		this.organicConversionTotal = this.getSeoTotal(
			this.analyticsData,
			"organic",
			7
		);
		this.organicRevenueTotal = this.getSeoTotal(
			this.analyticsData,
			"organic",
			8
		);
		this.organicConversionAverage = this.getSeoAverage(
			this.analyticsData,
			"organic",
			6
		);
		this.conversionRateColumnChartOptions = this.setColumnChartOptions(
			"Poids du SEO",
			this.formatValue(this.organicConversionAverage),
			this.formatValue(this.analyticsTotalData[6]),
			"Taux de conversion SEO",
			"Taux de conversion globale",
			"Taux de conversion",
			"%"
		);
	},
	updated() {
		this.loaded = true;
	}
};
</script>

<style scoped>
.comparing_div {
  margin: 5px;
  align-items: center;
}
.comparing_container {
  display: none;
  margin: 5px;
  background-color: rgb(245, 245, 245);
  border-radius: 5px;
}

.center {
  display: flex;
  justify-content: center;
}

.radial_container {
  display: flex;
}
.filter_container {
  display: flex;
  justify-content: space-between;
}

.filter_card {
  width: 50%;
  margin-bottom: 0em !important;
}
.global_value {
  font-size: px;
  font-weight: bold;
  color: black;
}

.txt_align_right {
  text-align: right;
}

.roundChart_card {
  margin-bottom: 2.2rem;
}
</style>
